'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var BaseFilterController = require('components/devices/controllers/base_filter_controller');
var HomeController = require('components/home/home_controller');
var ValueView = require('components/devices/views/tools/stats/value_view');
var StatsView = require('components/devices/views/tools/stats/stats_view');
var StatsDialogView = require('components/devices/views/tools/stats/stats_dialog_view');
var VirtualDeviceDialogView = require('components/devices/views/virtual/virtual_device_dialog_view');
var Devices = require('models/devices');
var Misc = require('utils/misc');

var StatsController = BaseFilterController.extend({
    show: function (params) {
        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                AppState.layout.breadcrumbs.reset();
                App.trigger('sidebar:default', 'stats');

                self.statsView = new StatsView({
                    controller: self,
                    onLoadComplete: function () {
                        App.showContentView(self.statsView);
                    },
                });
            },
        });
    },

    showDialog: function (request, refreshCb) {
        var defer = $.Deferred();
        this.refreshPage = refreshCb;
        var self = this;
        $.when(defer.promise()).done(function () {
            // show the dialog
            var dlg = new StatsDialogView({
                request: request,
                controller: self,
            });
            App.showModal(dlg);
        });

        if (!request.selectionID) {
            $.when(
                App.request('devices:selection', {
                    filter: request.filter,
                })
            ).done(function (sel) {
                request.selectionID = sel;
                defer.resolve();
            });
        } else {
            defer.resolve();
        }
    },

    addEditValue: function (ctx) {
        var self = this;
        AppState.requireColumns(function () {
            var isEdit = ctx.idx !== undefined;
            var item = ctx.data.series[ctx.idx];
            var isVirtual = Misc.isFilterTypeVirtual(ctx.data.filter.category);

            var dlg = new ValueView({
                deviceList: ctx.data.deviceList,
                values: Misc.selectWhere(AppState.uniqueColumns(), function (item) {
                    return isVirtual == (item.isVirtual || item.isVirtualIntern);
                }),
                cb: function (item) {
                    if (isEdit) {
                        ctx.data.series[ctx.idx] = item;
                    } else {
                        ctx.data.series.push(item);
                        item.idx = ctx.data.series.length - 1;
                    }
                    App.hideModal();
                    ctx.cb();
                },
                isEdit: isEdit,
                item: item,
            });
            App.showModal(dlg);
        });
    },

    deleteValue: function (data, idx) {
        data.series.splice(idx, 1);
    },

    saveVirtualDevice: function (data, selection) {
        var series = _.map(data.series, function (item) {
            var nameSuffix = '';
            if (Misc.isVirtual(item.value)) {
                // add aggregation method to name
                nameSuffix =
                    ' - ' +
                    Misc.selectWhereFirst(
                        Consts.Aggregation,
                        function (a) {
                            return a.id == item.aggregation;
                        },
                        'name'
                    );
            }

            return {
                aggregation: item.aggregation,
                value: item.value,
                name: item.name + nameSuffix,
            };
        });

        var dlg = new VirtualDeviceDialogView({
            series: series,
            filter: data.filter,
            selection: selection,
            controller: this,
            cb: function (virtualDevice) {
                var m = new Devices.Model(virtualDevice);
                m.save(
                    {},
                    {
                        success: function (m) {
                            App.hideModal(dlg);
                            App.trigger('Virtual:show', m.id);
                        },
                        error: function (err, r) {
                            var err = r.responseJSON || { error: r.responseText };
                            dlg.setError(err);
                        },
                    }
                );
            },
        });
        App.showModal(dlg);
    },

    setFilter: function (filter) {
        BaseFilterController.prototype.setFilter.apply(this, [filter]);
        AppState.setURLParameter(Misc.filterToMap(filter), 'extend');
    },
});

module.exports = StatsController;
